import { useQuery } from '@tanstack/react-query';

import { api, UNSCOPED } from '@/lib/api-client';
import { type Studio } from '@/models/studio';

import { studiosQueryKey } from './queryKeys';

/**
 * The Studios the viewer can reach — unpaginated, the set is small. Unscoped: the
 * list is what picks a Studio, so it must not echo the one in view.
 */
export const getStudios = async () => {
  const response = await api.get<{ studios: Studio[] }>('/v1/studios', {
    params: UNSCOPED,
  });
  return response.data;
};

export const getStudiosQueryOptions = () => ({
  queryKey: studiosQueryKey.all,
  queryFn: getStudios,
});

export const useGetStudios = () => useQuery(getStudiosQueryOptions());
